export default function Footer() {
    const getFullYearCopyright = () => {
        const d = new Date();
        if (d) {
            return d.getFullYear();
        } else {
            return "2022";
        }
    };

    return (
        <div className="navbar-light bg-light">
            <div className="container-fluid ">
                <div className="d-flex justify-content-center flex-nowrap align-items-center">
                    <div className="mx-2 p-3">Copyright © {getFullYearCopyright()}, R-DNAM ฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว</div>
                </div>
            </div>
        </div>
    );
}
